/**
 * LabelSuggestionField - NOT a Prisma enum. Identifies which legal-data
 * field a transient suggestion (deterministic or AI) targets. Deterministic
 * suggestions always run; AI only runs on explicit request
 * (plan.md decision 5, and `service/label-suggestion.service.ts`).
 */
export const LABEL_SUGGESTION_FIELDS = [
  'WEIGHT_G',
  'DENSITY_G_PER_ML',
  'LEGAL_NAME',
  'STORAGE_CONDITION',
  'ALLERGEN_SUBSTANCE',
] as const;
export type LabelSuggestionField = (typeof LABEL_SUGGESTION_FIELDS)[number];
